import styled from 'styled-components';
import { Row } from 'antd';

export const ProfileWrapper = styled.div`
  @media only screen and (min-width: 769px) {
    margin-right: 21px;
  }
`;

export const WrapperRow = styled(Row)`
  padding-top: 50px;
  display: ${props => (props.center ? 'flex' : 'inherit')};
  justify-content: ${props => (props.center ? 'center' : null)};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding-top: 40px;
  }
`;
